<script setup>
import {defineProps, defineEmits} from "vue";

defineProps({
    show: Boolean,
    block: Boolean,
    loading: Boolean,
    disabled: Boolean,
    error: Boolean,
});

const emit = defineEmits(["press"]);

function press() {
    emit('press');
}
</script>

<template>
    <w-btn
        v-if="show"
        :color="error ? 'red' : 'teal'"
        :loading="loading"
        :disabled="disabled"
        :block="block"
        :text="'Valider'"
        :icon="error ? 'mdi-alert' : 'mdi-check-all'"
        @press="press"
    />
</template>